import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

const loader = lazyForPaint(() => import(/* webpackChunkName: "request-details" */ './request-details-stateless'));

export default withAsync({ loader });
